<template>
  <Modal position="center" ref="modalRef" width="37rem">
    <template #body>
      <View direction="column" align="center" gap="md">
        <IconTile icon="check-circle" size="large" color="blue" shape="rounded" :colored-icon="true" />

        <Text variant="h2">Confirm pre-qualification?</Text>
        <Text variant="body-large" color="secondary" align="center">
          This property is in a jurisdiction that requires you to accept the applicant on credit, income and rental
          history before viewing the background report.
        </Text>
        <Text variant="body-large" color="secondary" align="center">
          You don't need to make a final offer — just confirm the applicant passes everything else. The background
          report opens as soon as you confirm.
        </Text>
      </View>
    </template>

    <template #footer>
      <View gap="md" justify="space-between" :grow="1" class="actions">
        <Button @click="modalRef?.close()" variant="ghost" :disabled="approving">Not yet</Button>
        <Button @click="approve()" variant="primary" :loading="approving">Yes, show background report</Button>
      </View>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, IconTile, Modal, Text, View } from '@tallo/design-system';

import { useRenterProfileStore } from '../store/renter-profile.store';

const props = defineProps<{
  applicationId: string;
}>();

const emit = defineEmits<{ approved: [] }>();

const renterProfileStore = useRenterProfileStore();
const modalRef = ref<InstanceType<typeof Modal>>();
const approving = ref(false);

async function approve(): Promise<void> {
  approving.value = true;
  try {
    const ok = await renterProfileStore.approveCriminalScreening(props.applicationId);
    if (ok) {
      modalRef.value?.close();
      emit('approved');
    }
  } finally {
    approving.value = false;
  }
}

defineExpose({ modalRef });
</script>

<style scoped lang="scss">
.actions > * {
  width: 100%;
}
</style>
